<div class="kraft-table-container">
  <div *ngIf="mode == pageModes.mpListe">
<!--    <a (click)="importMaklerpaket()" *ngIf="importBtAnzeigen"-->
<!--       class="mini-button" id="importButton"-->
<!--       mat-button>Neues Paket importieren</a>-->

<!--    <a (click)="uebergebeTeilpaket()" *ngIf="uebergabeBtAnzeigen"-->
<!--       [disabled]="paketBearbeitungDisabledPruefOk"-->
<!--       [ngClass]="paketBearbeitungDisabledPruefOk ? 'mini-button-disabled' : 'mini-button'"-->
<!--       id="uebergebePaketButton"-->
<!--       mat-button>Teilpaket übergeben</a>-->
°
<!--    <a (click)="loescheTeilpaket()" *ngIf="loeschenBtAnzeigen"-->
<!--       [disabled]="paketLoeschenDisabled"-->
<!--       [ngClass]="paketLoeschenDisabled ? 'mini-button-disabled' : 'mini-button'" id="loeschePaketButton"-->
<!--       mat-button>Teilpaket löschen!</a>-->

<!--    <a (click)="zuruecksendenTeilpaket()" *ngIf="zuruecksendenBtAnzeigen"-->
<!--       [disabled]="paketBearbeitungDisabledInFreigabe"-->
<!--       [ngClass]="paketBearbeitungDisabledInFreigabe ? 'mini-button-disabled' : 'mini-button'"-->
<!--       id="zuruecksendenPaketButton"-->
<!--       mat-button>Teilpaket zurücksenden</a>-->

<!--    <a (click)="freigebenTeilpaket()" *ngIf="freigebenBtAnzeigen"-->
<!--       [disabled]="paketBearbeitungDisabledInFreigabe"-->
<!--       [ngClass]="paketBearbeitungDisabledInFreigabe ? 'mini-button-disabled' : 'mini-button'"-->
<!--       id="freigebenPaketButton"-->
<!--       mat-button>Teilpaket freigeben</a>-->


<!--    <a (click)="einspielenTeilpaket()" *ngIf="einspielenBtAnzeigen"-->
<!--       [disabled]="paketBearbeitungDisabledFreigegeben"-->
<!--       [ngClass]="(paketBearbeitungDisabledFreigegeben || paketBearbeitungDisabled) ? 'mini-button-disabled' : 'mini-button'"-->
<!--       id="einspielenPaketButton"-->
<!--       mat-button>Teilpaket einspielen</a>-->

<!--    <a (click)="ablehnenTeilpaket()" *ngIf="ablehnenBtAnzeigen"-->
<!--       [disabled]="paketBearbeitungDisabledInFreigabe"-->
<!--       [ngClass]="paketBearbeitungDisabledInFreigabe ? 'mini-button-disabled' : 'mini-button'"-->
<!--       id="ablehnenPaketButton"-->
<!--       mat-button>Teilpaket ablehnen</a>-->

    <a class="mini-button" id="zurueckButton" mat-button routerLink="/index-kraft">Zurück</a>
  </div>
  <br>
  <div *ngIf="mode == pageModes.mpUpload">
    <app-massenberechnung-upload-kraft (abbruchEvent)="anzeigeMpliste()"
                                       (uploadStatusEvent)="uploadStatus($event)"
                                       [userInfo]="userinfo">
    </app-massenberechnung-upload-kraft>
  </div>
</div>

